import {DefaultEventsMap, DeviceType, ModuleIsEnabledFilter} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {BuyBonusBalanceView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceView';
import {BuyBonusBalanceViewPortrait} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceViewPortrait';
import {BuyBonusBalanceViewLandscape} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusBalance/BuyBonusBalanceViewLandscape';
import {isEnabledRubyCoins} from '@gongxigames/framework/slot/modules/buyBonus/isEnabledRubyCoins';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';

export class BuyBonusBalanceViewMobile extends ScreenOrientedView<DefaultEventsMap, BuyBonusBalanceView> {
    public static readonly NAME: symbol = Symbol('BuyBonusBalanceViewMobile');
    public static layer = LAYERS.OVER_KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledRubyCoins;

    protected landscapeViewName: symbol = BuyBonusBalanceViewLandscape.NAME;
    protected portraitViewName: symbol = BuyBonusBalanceViewPortrait.NAME;

    public setDisabledBalanceState(): void {
        this._views.forEach((view: BuyBonusBalanceView) => {
            view.setDisabledBalanceState();
        });
    }

    public setEnabledBalanceState(): void {
        this._views.forEach((view: BuyBonusBalanceView) => {
            view.setEnabledBalanceState();
        });
    }

    public updateRealMoneyValues(value: number): void {
        this._views.forEach((view: BuyBonusBalanceView) => {
            view.updateRealMoneyValues(value);
        });
    }

    public updateRubyValues(value: number): void {
        this._views.forEach((view: BuyBonusBalanceView) => {
            view.updateRubyValues(value);
        });
    }

    public prepareAnimation(): void {
        this._views.forEach((view: BuyBonusBalanceView) => {
            view.prepareAnimation();
        });
    }
}
